export class DropdownItemEventTypeInput {
    constructor(dropdownItemEventTypeInputId: number, dropdownItemId: number, eventTypeInputId: number, mandatory: boolean) {
        this.dropdownItemEventTypeInputId = dropdownItemEventTypeInputId;
        this.dropdownItemId = dropdownItemId;
        this.eventTypeInputId = eventTypeInputId;
        this.mandatory = mandatory;
    }
    dropdownItemEventTypeInputId: number;
    dropdownItemId: number;
    eventTypeInputId: number;
    mandatory: boolean;
}
